<template>
  <Teleport to="body">
    <Transition name="status-modal-overlay">
      <div
        v-if="show"
        class="success-modal-overlay"
        role="presentation"
        @click.self="closeModal"
      >
        <Transition name="status-modal-panel" appear>
          <div
            v-if="show"
            class="success-modal"
            role="alertdialog"
            aria-modal="true"
            aria-labelledby="success-modal-title"
            @click.stop
          >
            <header class="success-modal-header">
              <h3 id="success-modal-title">{{ title }}</h3>
              <button
                type="button"
                class="success-modal-close"
                aria-label="Close"
                @click="closeModal"
              >
                <i class="bi bi-x-lg" aria-hidden="true"></i>
              </button>
            </header>
            <div class="success-modal-body">
              <div class="status-modal-body-content">
                <div class="status-modal-icon-wrap">
                  <span class="status-modal-icon-ring status-modal-icon-ring--success" aria-hidden="true"></span>
                  <div class="status-modal-icon status-modal-icon--success" aria-hidden="true">
                    <i class="bi bi-check-circle-fill"></i>
                  </div>
                </div>
                <div
                  v-if="messageLines.length"
                  class="status-modal-message status-modal-message--success"
                >
                  <p
                    v-for="(line, index) in messageLines"
                    :key="'msg-' + index"
                    class="status-modal-message-line"
                    :style="{ animationDelay: `${0.14 + index * 0.07}s` }"
                  >{{ line }}</p>
                </div>
              </div>
            </div>
            <footer class="success-modal-footer">
              <button
                v-if="secondaryButtonText"
                type="button"
                class="status-modal-btn status-modal-btn--secondary"
                @click="secondaryAction"
              >{{ secondaryButtonText }}</button>
              <button
                type="button"
                class="status-modal-btn status-modal-btn--primary"
                @click="closeModal"
              >{{ buttonText }}</button>
            </footer>
          </div>
        </Transition>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import './SuccessModal.css';

export default {
  name: 'SuccessModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Success',
    },
    message: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: 'OK',
    },
    secondaryButtonText: {
      type: String,
      default: '',
    },
  },
  emits: ['close', 'secondary'],
  computed: {
    messageLines() {
      return this.splitMessageLines(this.message);
    },
  },
  methods: {
    splitMessageLines(text) {
      if (!text || !String(text).trim()) return [];
      const lines = String(text)
        .split('\n')
        .map((line) => line.trim())
        .filter(Boolean);
      return lines.length ? lines : [String(text).trim()];
    },
    closeModal() {
      this.$emit('close');
    },
    secondaryAction() {
      this.$emit('secondary');
    },
  },
};
</script>
